<template>
    <div class="pointer-events-none absolute inset-x-5 inset-be-5 overflow-clip">
        <transition
            enterFromClass="translate-y-full opacity-0"
            enterActiveClass="transition duration-500 ease-out"
            leaveActiveClass="transition duration-500 ease-out"
            leaveToClass="translate-y-full opacity-0"
        >
            <div v-if="props.loading || props.disabled" class="flex gap-1.5">
                <div
                    v-for="item in 96"
                    :key="item"
                    data-test="loading-bar"
                    class="flex h-14 min-w-[8px] origin-bottom rounded-t-full transition-colors duration-300"
                    :class="[
                        item % 7 ? (item % 3 ? 'translate-y-8' : 'translate-y-4') : '',
                        props.loading ? 'bg-sky-200 motion-safe:animate-[pulse_1.3s_infinite]' : 'bg-slate-200',
                    ]"
                    :style="
                        item % 7 ? (item % 5 ? 'animation-delay: 0s' : 'animation-delay: .2s') : 'animation-delay: .4s'
                    "
                />
            </div>
        </transition>
    </div>
</template>

<script setup>
const props = defineProps({
    loading: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
</script>
